// src/components/Dashboard/StatCard.js
import React from 'react';
import { Paper, Typography } from '@mui/material';

const StatCard = ({ title, value, unit, color }) => (
    <Paper elevation={3} sx={{ p: 2, backgroundColor: color, color: 'white', borderRadius: '10px' }}>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="h6">{value}</Typography>
        <Typography variant="caption">{unit}</Typography>
    </Paper>
);

export default StatCard;